/* WorkingMaze caption phrases — ported verbatim from brand.jsx.
   Ordered roughly by theme: escape, labyrinth, workshop, pantheon,
   underworld, fates/muses, titans, monsters, omens, dry/irreverent. */

export const WORKING_PHRASES: readonly string[] = [
  // wings / escape
  'drafting the labyrinth',
  'smelting gold',
  'arranging feathers',
  'glueing feathers',
  'setting beeswax',
  'trapping the minotaur',
  'cursing king minos',
  'catching birds',
  'calling ariadne',
  "pulling ariadne's thread",
  'sailing to crete',
  'plotting the escape',
  'stealing the thread',
  'sharpening the chisel',
  'bribing the guards',
  'waxing the wings',
  'testing the updraft',
  'mourning icarus',
  'burying icarus',
  'fleeing naxos',
  'charting the aegean',
  'carving cedar',
  'forging the axe',
  'reading the oracle',
  'appeasing poseidon',
  'summoning talos',
  'fooling pasiphae',
  'housing the minotaur',
  'measuring the maze',
  'greasing the gears',
  'counting the tributes',
  'binding the wings',
  'tightening straps',
  'threading the needle',
  'whispering to ariadne',
  'shaping the wax',
  'tightening the harness',
  'sealing the seams',
  'catching the updraft',
  'reading the winds',
  'charting the skies',
  'warning icarus',
  'counting the feathers',
  'staying below helios',
  'rising from crete',
  'not looking down',
  // labyrinth
  'laying the corridors',
  'sealing a dead end',
  "spooling ariadne's thread",
  'cutting the thread',
  'locking the minotaur',
  'misleading theseus',
  // workshop
  'stoking the forge',
  'hammering the bronze',
  'cooling the bronze',
  'pouring the mold',
  'carving in wax',
  'oiling the hinges',
  'fitting the gears',
  'winding the automaton',
  'animating the bronze',
  'waking talos',
  // broader pantheon
  'consulting the oracle',
  'paying the ferryman',
  'crossing the styx',
  'feeding cerberus',
  'spinning the thread',
  'measuring the thread',
  'waking the muses',
  'invoking athena',
  'calling hephaestus',
  "borrowing prometheus's fire",
  "tuning apollo's lyre",
  'dodging zeus',
  // underworld
  'bribing charon',
  "counting charon's coins",
  'leashing cerberus',
  "passing hades's gate",
  'weighing souls',
  'drinking from lethe',
  'avoiding tartarus',
  "escaping elysium's pull",
  'waking persephone',
  "rolling sisyphus's stone",
  "filling tantalus's cup",
  // olympians at work
  'consulting athena',
  "borrowing hermes's sandals",
  'forging with hephaestus',
  "sharpening ares's spear",
  "stringing apollo's bow",
  "aiming artemis's arrow",
  'calming poseidon',
  "steadying zeus's hand",
  "counting hera's peacocks",
  "polishing aphrodite's mirror",
  'taming dionysus',
  // fates & muses
  "spinning clotho's thread",
  "measuring lachesis's thread",
  "dulling atropos's shears",
  'summoning calliope',
  'invoking mnemosyne',
  'asking the muses',
  // titans & primordials
  "stealing prometheus's fire",
  'relieving atlas',
  'holding up the sky',
  'outrunning chronos',
  'waking gaia',
  'sailing past oceanus',
  // monsters & trials
  'outsmarting the sphinx',
  'answering the riddle',
  "plugging the sirens' song",
  'threading scylla',
  'skirting charybdis',
  'slipping past argus',
  'turning from medusa',
  'catching pegasus',
  'feeding the chimera',
  'slaying the hydra',
  'cauterizing the hydra',
  'cleaning augean stables',
  // oracles, heroes, omens
  'consulting delphi',
  'reading the entrails',
  'following the omen',
  "opening pandora's jar",
  "closing pandora's jar",
  'heeding cassandra',
  'ignoring cassandra',
  'chasing the fleece',
  'rigging the argo',
  'launching a thousand ships',
  // dry / irreverent
  'ghosting hera',
  'invoicing zeus',
  'filing with the fates',
  'negotiating with hades',
  'reminding apollo',
  'unsubscribing from eris',
];
